var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoAlt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 31,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 .424V30.5h30.065L0 .424z",
    fill: "#5073F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.065 30.5V.424L15.028 15.462 0 30.5h30.065z",
    fill: "url(#paint0_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 30.5h30.065L15.028 15.462 0 30.5z",
    fill: "url(#paint1_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.435 8.01h.293l8.492 10.238L62.615 8.01h.292v18.496h-2.635v-9.5c0-1.007.098-2.652.098-2.652s-.879 1.376-1.595 2.216l-4.457 5.538h-.326l-4.457-5.538c-.684-.84-1.562-2.216-1.562-2.216s.098 1.611.098 2.652v9.5h-2.636V8.01z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.406 17.342c0-5.472 4.067-9.4 9.175-9.4 5.076 0 9.143 3.928 9.143 9.4 0 5.471-4.067 9.399-9.143 9.399-5.108 0-9.175-3.928-9.175-9.4zm15.488 0c0-3.894-2.603-6.848-6.313-6.848-3.709 0-6.344 2.92-6.344 6.848 0 3.893 2.635 6.847 6.344 6.847 3.677 0 6.313-2.954 6.313-6.847z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M92.386 8.178h5.759c5.694 0 9.468 3.659 9.468 9.164s-3.774 9.164-9.468 9.164h-5.76V8.178zm5.564 15.81c4.62 0 6.8-2.753 6.8-6.646 0-3.894-2.18-6.647-6.8-6.647H95.15v13.293h2.799z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M119.684 15.798c-.455-1.075-.878-2.72-.878-2.72s-.423 1.645-.879 2.72l-4.653 10.708h-2.668l8.07-18.496h.325l8.232 18.496h-2.863l-4.686-10.708z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M131.918 8.178h2.766v15.81h8.199v2.518h-10.965V8.178z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M149.846 20.698l-6.735-12.52h3.058l4.035 7.552c.553 1.007 1.074 2.652 1.074 2.652s.553-1.611 1.073-2.652l3.905-7.552h2.83l-6.442 12.352v5.942h-2.765v-5.774h-.033z",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M161.234 22.947l2.277-1.309c.846 1.41 1.92 2.551 4.068 2.551 1.789 0 3.091-1.007 3.091-2.517 0-1.578-1.042-2.283-2.961-3.19l-1.172-.536c-2.57-1.175-4.164-2.518-4.164-5.371 0-2.719 2.05-4.666 4.978-4.666 2.342 0 3.937.907 5.011 2.887l-2.18 1.376c-.684-1.208-1.465-1.779-2.831-1.779-1.399 0-2.31.906-2.31 2.115 0 1.376.748 1.98 2.57 2.786l1.139.537c3.026 1.376 4.653 2.82 4.653 5.774 0 3.189-2.441 5.068-5.759 5.068-3.384.068-5.401-1.644-6.41-3.726z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M181.797 10.695h-5.271V8.178h13.275v2.517h-5.271v15.81h-2.733v-15.81z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 30.067,
    y1: 30.5,
    x2: 17.071,
    y2: 6.048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5236B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59E2B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 14.745,
    y1: 15.428,
    x2: 30.549,
    y2: 30.154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59E2B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.983,
    stopColor: "#6464E8"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAlt);
export default __webpack_public_path__ + "static/media/logo_alt.92a9cab4.svg";
export { ForwardRef as ReactComponent };